import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'
import {
  designRirekisho002DocPaperStyle,
  designRirekisho002DocPaperPage2Style,
  designRirekisho002SidebarStyle
} from '@/utils/format-edit/designRirekisho002PreviewStyles'
import DesignRirekisho002PreviewDocPage2 from '@/components/format-edit/design-rirekisho/DesignRirekisho002PreviewDocPage2.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekisho002PreviewDoc',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    formatId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean, formatId?: string };



const {
  mypr,
  checkValid,
  formLib,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  tel,
  formatedCreateDate
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { reason: 180, request: 180, mypr: 180 },
  overflowFields: ['reason', 'reasonNew', 'request', 'addressFurigana', 'mypr'],
  revalidateOnFormatDataChange: true
})

const docPaperStyle = computed(() =>
  designRirekisho002DocPaperStyle(!!props.isSample)
)
const docPaperPage2Style = computed(() =>
  designRirekisho002DocPaperPage2Style(!!props.isSample)
)
const sidebarStyle = computed(() =>
  designRirekisho002SidebarStyle(!!props.isSample)
)

expose({ checkValid })

return { __sfc: true,props, mypr, checkValid, formLib, highlightMessage, goCardTo, highLightClass, classObject, tel, formatedCreateDate, docPaperStyle, docPaperPage2Style, sidebarStyle, hobbyOptions, DesignRirekisho002PreviewDocPage2 }
}

})